import * as React from 'react';

const CreditCardBackFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="credit-card-back-fill_svg__a"
                d="M12 11H6.5v-1H12v1zM2 11v-1h2l.008 1H2zM0 6v8h20V6H0zm20-2V0H0v4h20z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(2 5)">
            <mask id="credit-card-back-fill_svg__b" fill="#fff">
                <use xlinkHref="#credit-card-back-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#credit-card-back-fill_svg__a" />
            <g mask="url(#credit-card-back-fill_svg__b)">
                <path fill="#000" d="M-2-5h24v24H-2z" />
            </g>
        </g>
    </svg>
);

CreditCardBackFillSvg.displayName = 'CreditCardBackFillSvg';
export default CreditCardBackFillSvg;
